import axios from "axios";

import { getAuthPath } from "./auth_base/cookie_auth";
import { headerAuth } from "./auth_base/auth-service";


type headerType = {
  Authorization?: string;
  Bearer?: string;
};


//Products
export  function fetchProducts(options: any = false) {
  const load: any = options ? JSON.stringify(options) : JSON.stringify({});
  const url =  getAuthPath("all_products");
    return axios.post(url, load).then((response) => {
      return response.data;
    });
}

export  function fetchFeaturedProducts(options: any = false) {
  const load: any = options ? JSON.stringify(options) : JSON.stringify({});
  const url =  getAuthPath("all_featured_products");
    return axios.post(url, load).then((response) => { 
      return response.data;
    });

}

export function fetchProductCategories() {
  const url =  getAuthPath("product_categories");
    return axios.post(url).then((response) => {
      return response.data;
    });
}

//articles_by_category
export  function fetchProductsByCategory(options: any = false) {
  const load: any = options ? JSON.stringify(options) : JSON.stringify({});
  const url =  getAuthPath("products_by_category");
    return axios.post(url, load).then((response) => {
      return response.data;
    });
}

export  function fetchProductDetails(slug: string | number) {
  const url = getAuthPath("product_details");
    return axios.post(url, { slug: slug }).then((response) => {
      return response.data;
    });
}


export  function fetchUserDetails(id: string | number) {
  const url =  getAuthPath("user_details");
    return axios.post(url, { id:id }).then((response) => {
      console.log("Response::", response);
      return response.data;
    });
}


export  function push_more_list(func: any, options: any) {
  return  func({
    offset: options.offset,
  });
}

//HTTP

export   function post(data: any, endpoint: string) {
  const url =   getAuthPath(endpoint);
  const auth:headerType = headerAuth();
  const hdrs = {...auth,
    "Content-Type": "application/json",
      Accept: "application/json"
    };

    return axios
      .post(url, data, { headers: hdrs })
      .then((response) => {
        let resp = response.data;
        return resp;
      });


}

export  function checkSession() {
  const path =  getAuthPath("checkSession");
      return getHeader(path);
}


export function getHeader(endpoint: string) {
    const path =  getAuthPath(endpoint);   
const auth:headerType = headerAuth();
  const hdrs = {...auth,
    "Content-Type": "application/json",
      Accept: "application/json"
    };
    return axios
      .get(path, { headers: hdrs })
      .then((response) => {
        let resp = response.data;
        return resp;
      });
  }